import { render, staticRenderFns } from "./ApiResourceDetailForm.vue?vue&type=template&id=8be2a186&"
import script from "./ApiResourceDetailForm.vue?vue&type=script&lang=js&"
export * from "./ApiResourceDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports